import React from "react";
import { FiArrowRight } from "react-icons/fi";

const ViewMaterials = ({ v }) => {
  return (
    <span className="flex items-center justify-center gap-2 text-sm font-semibold text-neutral-400 cursor-not-allowed">
      Coming Soon
      <FiArrowRight className="w-4 h-4" />
    </span>
  );
};

export default ViewMaterials;
